import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config/api";
import axiosInstance from "../../../config/axiosConfig";

// ✅ Thunk: Create Training
export const createTrainingCheck = createAsyncThunk(
  "myTrainings/createTraining",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${config.backendUrl}/my-training/create`,
        payload
      );
      return response.data; // contains { message, training }
    } catch (error) {
      console.error("❌ createTraining thunk error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Slice
const myTrainingSlice = createSlice({
  name: "myTrainingsCreate",
  initialState: {
    trainings: [],
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearTrainingMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // --- CREATE TRAINING ---
      .addCase(createTrainingCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(createTrainingCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        if (action.payload.training) {
          state.trainings.push(action.payload.training);
        }
      })
      .addCase(createTrainingCheck.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.error || "Failed to create training. Please try again.";
      });
  },
});

// ✅ Export actions & reducer
export const { clearTrainingMessages } = myTrainingSlice.actions;
export default myTrainingSlice.reducer;
